export default "__VITE_ASSET__ooFN27VX__"